import { render, staticRenderFns } from "./ResizeUpload.vue?vue&type=template&id=3fa82e96&scoped=true&"
import script from "./ResizeUpload.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ResizeUpload.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ResizeUpload.vue?vue&type=style&index=0&id=3fa82e96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa82e96",
  null
  
)

export default component.exports